import { jarvisPrimeRmsConstants } from "./jarvisPrimeRmsConstants";

const jarvisPrimeRmsActions = {}

jarvisPrimeRmsActions.getRMSDetails = () => ({
    type: jarvisPrimeRmsConstants.PRIME_RMS_SAGA
})

export { jarvisPrimeRmsActions };